import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Hi.`}</h2>
    <p>{`I'm Braden - I'm a software engineer at Microsoft. I've been in software development for four years and have loved every minute of it. This is where I host my blog and personal projects.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      